import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { Box } from '@mui/material';
import { MenuRadioGroup, MenuButton } from '@szhsin/react-menu';
import { isBoolean } from 'lodash-es';
import PropTypes from 'prop-types';
import { StyledMenuContainer, StyledControlledMenuContainer, StyledMenuItem, StyledMenuItemInside, StyledSubMenuItem, StyledFilterNumber, StyledFilterButton } from './Menu.styles.js';
import Checkbox from '../Checkbox/Checkbox.js';
import Radio from '../Radio/Radio.js';
const _excluded = ["itemList", "isOpen", "onClose", "anchorRef", "menuButton", "isFilter", "topFilterNumber", "zIndex", "size", "filterText"],
  _excluded2 = ["func", "value", "children", "checked", "backgroundColor"],
  _excluded3 = ["func", "value", "children", "subMenu", "needIcon", "checked", "onRadioChange", "filterNumber", "backgroundColor"];
function Menu(_ref) {
  let {
      itemList,
      isOpen,
      onClose,
      anchorRef,
      menuButton,
      isFilter,
      topFilterNumber,
      zIndex,
      size,
      filterText
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  const renderMenuItem = (_ref2, index) => {
    let {
        func,
        value,
        children,
        checked,
        backgroundColor
      } = _ref2,
      otherItemProps = _objectWithoutProperties(_ref2, _excluded2);
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(StyledMenuItem, _extends({}, otherItemProps, {
      onClick: e => {
        e.keepOpen = true;
        e.stopPropagation = true;
        if (func) {
          func(e);
        }
      },
      value: value,
      checked: checked
      // eslint-disable-next-line react/no-array-index-key
    }), otherItemProps.type === 'checkbox' && /*#__PURE__*/React__default.createElement(Checkbox, {
      checked: checked
    }), otherItemProps.type === 'radio' && /*#__PURE__*/React__default.createElement(Radio, {
      checked: checked
    }), /*#__PURE__*/React__default.createElement(StyledMenuItemInside, {
      backgroundColor: backgroundColor
    }, children)));
  };
  const renderSubMenu = (_ref3, index) => {
    let {
        func,
        value,
        children,
        subMenu,
        needIcon,
        checked,
        onRadioChange,
        filterNumber,
        backgroundColor
      } = _ref3,
      otherItemProps = _objectWithoutProperties(_ref3, _excluded3);
    if (otherItemProps.type === 'radioGroup') {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(StyledSubMenuItem, _extends({}, otherItemProps, {
        overflow: "auto",
        position: "anchor",
        label: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, needIcon && /*#__PURE__*/React__default.createElement(Box, {
          mr: "5px"
        }, /*#__PURE__*/React__default.createElement(Radio, {
          checked: checked
        })), children, ' ', filterNumber ? /*#__PURE__*/React__default.createElement(StyledFilterNumber, null, filterNumber) : null)
      }), /*#__PURE__*/React__default.createElement(MenuRadioGroup, {
        value: value,
        onRadioChange: onRadioChange
      }, subMenu.map((subItem, subIndex) => {
        var _subItem$subMenu;
        return subItem.subMenu ? /*#__PURE__*/React__default.createElement(Box, {
          key: "".concat(index, "-").concat(subIndex)
        }, /*#__PURE__*/React__default.createElement(StyledSubMenuItem, _extends({}, otherItemProps, {
          overflow: "auto",
          position: "anchor",
          sx: {
            padding: 0,
            paddingRight: 0
          },
          label: /*#__PURE__*/React__default.createElement(Box, {
            display: "flex",
            alignItems: "center",
            padding: "7.5px 12px",
            onClick: e => {
              // e.stopPropagation();
              subItem.func({
                value: subItem.value
              });
            }
          }, (otherItemProps.type === 'radio' || otherItemProps.type === 'radioGroup') && /*#__PURE__*/React__default.createElement(Radio, {
            checked: subItem.checked
          }), /*#__PURE__*/React__default.createElement(StyledMenuItemInside, {
            backgroundColor: backgroundColor
          }, subItem.children))
        }), /*#__PURE__*/React__default.createElement(React__default.Fragment, null, subItem === null || subItem === void 0 || (_subItem$subMenu = subItem.subMenu) === null || _subItem$subMenu === void 0 ? void 0 : _subItem$subMenu.map((subSubItem, subSubIndex) => subSubItem.subMenu ? /*#__PURE__*/React__default.createElement(React__default.Fragment, {
          key: "".concat(index, "-").concat(subIndex, "-").concat(subSubIndex)
        }, renderSubMenu(subSubItem, "".concat(index, "-").concat(subIndex, "-").concat(subSubIndex))) : /*#__PURE__*/React__default.createElement(React__default.Fragment, {
          key: "".concat(index, "-").concat(subIndex, "-").concat(subSubIndex)
        }, /*#__PURE__*/React__default.createElement(MenuRadioGroup, {
          value: value,
          onRadioChange: subItem.onRadioChange
        }, renderMenuItem(subSubItem))))))) : /*#__PURE__*/React__default.createElement(React__default.Fragment, {
          key: "".concat(index, "-").concat(subIndex)
        }, renderMenuItem(subItem));
      }))));
    }
    if (otherItemProps.type === 'checkbox') {
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(StyledSubMenuItem, _extends({}, otherItemProps, {
        overflow: "auto",
        position: "anchor",
        label: /*#__PURE__*/React__default.createElement(Box, {
          display: "flex",
          alignItems: "center",
          onClick: e => {
            e.stopPropagation();
            func({
              value,
              checked: !checked
            });
          }
        }, otherItemProps.type === 'checkbox' && /*#__PURE__*/React__default.createElement(Checkbox, {
          checked: checked
        }), otherItemProps.type === 'radio' && /*#__PURE__*/React__default.createElement(Radio, {
          checked: checked
        }), /*#__PURE__*/React__default.createElement(StyledMenuItemInside, {
          backgroundColor: backgroundColor
        }, children))
      }), subMenu.map((subItem, subIndex) => subItem.subMenu ? /*#__PURE__*/React__default.createElement(React__default.Fragment, {
        key: "".concat(index, "-").concat(subIndex)
      }, renderSubMenu(subItem, "".concat(index, "-").concat(subIndex))) : /*#__PURE__*/React__default.createElement(React__default.Fragment, {
        key: "".concat(index, "-").concat(subIndex)
      }, renderMenuItem(subItem)))));
    }
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(StyledSubMenuItem, _extends({}, otherItemProps, {
      overflow: "auto",
      position: "initial"
      // eslint-disable-next-line react/no-array-index-key
      ,

      value: value,
      label: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children, ' ', filterNumber ? /*#__PURE__*/React__default.createElement(StyledFilterNumber, null, filterNumber) : null)
    }), subMenu.map((subItem, subIndex) => subItem.subMenu ? /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: "".concat(index, "-").concat(subIndex)
    }, renderSubMenu(subItem, "".concat(index, "-").concat(subIndex))) : /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: "".concat(index, "-").concat(subIndex)
    }, renderMenuItem(subItem)))));
  };
  const renderMenuButton = () => {
    if (menuButton) {
      return menuButton;
    }
    if (isFilter) {
      return /*#__PURE__*/React__default.createElement(StyledFilterButton, {
        size: size
      }, /*#__PURE__*/React__default.createElement("i", {
        className: "meta-crm-icon-ic_filter2 font-size-14"
      }), ' ', /*#__PURE__*/React__default.createElement(Box, {
        ml: "4px",
        fontSize: 12
      }, filterText), ' ', topFilterNumber ? /*#__PURE__*/React__default.createElement(StyledFilterNumber, null, topFilterNumber) : null);
    }
    return /*#__PURE__*/React__default.createElement(MenuButton, null, "Menu");
  };
  const renderMenu = () => /*#__PURE__*/React__default.createElement(StyledMenuContainer, _extends({}, otherProps, {
    overflow: "auto",
    position: "initial",
    menuButton: renderMenuButton(),
    zIndex: zIndex,
    transition: true,
    onItemClick: e => {
      e.stopPropagation = true;
    }
  }), itemList.map((item, index) => item.subMenu ? /*#__PURE__*/React__default.createElement(React__default.Fragment, {
    key: index
  }, renderSubMenu(item, index)) : /*#__PURE__*/React__default.createElement(React__default.Fragment, {
    key: index
  }, renderMenuItem(item))));
  const renderControlledMenu = () => /*#__PURE__*/React__default.createElement(StyledControlledMenuContainer, {
    onClose: onClose,
    state: isOpen ? 'open' : 'closed',
    anchorRef: anchorRef
  }, itemList.map((item, index) => item.subMenu ? /*#__PURE__*/React__default.createElement(React__default.Fragment, {
    key: index
  }, renderSubMenu(item, index)) : /*#__PURE__*/React__default.createElement(React__default.Fragment, {
    key: index
  }, renderMenuItem(item))));
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, isBoolean(isOpen) ? renderControlledMenu() : renderMenu());
}
Menu.propTypes = {
  menuButton: PropTypes.oneOfType([PropTypes.node, PropTypes.elementType]),
  anchorRef: PropTypes.oneOfType([PropTypes.node, PropTypes.instanceOf(Element), PropTypes.oneOf([null]), PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  })]),
  itemList: PropTypes.arrayOf(PropTypes.shape({}).isRequired),
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  isFilter: PropTypes.bool,
  topFilterNumber: PropTypes.number,
  zIndex: PropTypes.number,
  size: PropTypes.oneOf(['extraLarge', 'large', 'medium', 'small', 'extraSmall', 'extraSmallSmall']),
  needIcon: PropTypes.bool,
  filterText: PropTypes.string
};
Menu.defaultProps = {
  itemList: [],
  menuButton: null,
  isOpen: null,
  onClose: null,
  anchorRef: null,
  isFilter: false,
  topFilterNumber: null,
  zIndex: 200,
  size: 'small',
  needIcon: false,
  filterText: 'Filter'
};
export { Menu as default };